module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_05 (2).9d7b885d.png";